import {
  LOAD_LOCATIONS_BEGIN,
  LOAD_LOCATIONS_SUCCESS,
  LOAD_LOCATIONS_FAILED,
  CLEAR_LOCATIONS,
} from "../actions/locationsactions";

const initialState = {
  locations: [],
};

export function locationsReducer(state = initialState, action) {
  const nextState = Object.assign({}, state);

  switch (action.type) {
    case LOAD_LOCATIONS_BEGIN:
      return nextState;
    case CLEAR_LOCATIONS:
      nextState.locations = [];
      return nextState;
    case LOAD_LOCATIONS_SUCCESS:
      nextState.locations = action.locations;
      return nextState;
    case LOAD_LOCATIONS_FAILED:
      return nextState;
    default:
      return state;
  }
}
